<div class="wrapper wrapper-form-dialog">
  <div mat-dialog-title class="pb-8 d-flex align-center justify-content-between mb-0">
    <span class="title t-title-semibold">{{ options.title ? options.title : 'Add' }}</span>
    <button *ngIf="options.hasCloseButton" mat-icon-button [mat-dialog-close]="options?.closeAction">
      <mat-icon class="icon-button">clear</mat-icon>
    </button>
  </div>

  <div class="content">
    <div
      mat-dialog-content
      class="pb-16 pt-16"
      [class.dark-theme]="options.currentThemeMode === 'dark'"
      [class.light-theme]="options.currentThemeMode === 'light'"
      [class.dark-theme-bg-color]="options.currentThemeMode === 'dark'"
      [class.light-theme-bg-color]="options.currentThemeMode === 'light'"
    >
      <fb-editor class="w-full" [config]="config" [form]="form">
        <ng-container *fbTemplate="let data of 'vehiclesSelectedTemplate'">
          <div class="d-flex flex-wrap align-items-center">
            <div class="w-full">
              Selected vehicles <span class="t-caption-regular">(by default, all vehicles are selected)</span>:
            </div>

            <span
              [class.b-greyscale-700]="options.currentThemeMode === 'dark'"
              [class.b-light-stroke]="options.currentThemeMode === 'light'"
              class="mr-4 mt-8 py-8 px-16 border-radius-8"
              *ngFor="let item of options.templateData | async"
              >{{ item.vehicleId }}</span
            >
          </div>
        </ng-container>
        <ng-container *fbTemplate="let data of 'quarterTemplate'">
          <div class="d-flex align-items-center">
            <fb-editor-field
              class="d-flex"
              [type]="data.config.templateType"
              [config]="data.config"
              [control]="data.control"
            ></fb-editor-field>
            <div class="terms-conditions t-footnote-medium ml-8">or</div>
          </div>
        </ng-container>
      </fb-editor>
    </div>
  </div>

  <div mat-dialog-actions class="justify-content-between">
    <div class="buttons">
      <ng-container>
        <button matRipple class="btn-cancel t-footnote-semibold" (click)="onClose()">
          {{ 'Cancel' | translate | async }}
        </button>

        <button matRipple [disabled]="!form.valid" class="btn-success t-footnote-semibold" (click)="onSubmit()">
          {{ options.accesButtonText ? options.accesButtonText : ('Save' | translate | async) }}
        </button>
      </ng-container>
    </div>
  </div>
</div>
